"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./RadioTabs.css");
var RadioGroup_1 = require("../../RadioGroup");
var Tabs_1 = require("../Tabs");
var RadioTabs = /** @class */ (function (_super) {
    __extends(RadioTabs, _super);
    function RadioTabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioTabs.prototype.render = function () {
        return (React.createElement(Tabs_1.default, null, _super.prototype.render.call(this)));
    };
    return RadioTabs;
}(RadioGroup_1.default));
exports.default = RadioTabs;
//# sourceMappingURL=RadioTabs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/RadioTabs/RadioTabs.js
// module id = 1261
// module chunks = 8